import { datadogRum } from '@datadog/browser-rum';

/**
 * Sends a custom RUM action.
 *
 * Calls made before RUM is initialized are buffered by the SDK and dropped if
 * it never starts (localhost, disallowed env, declined cookies).
 *
 * @param name - A stable action name, see the `mint-datadog-action-names` skill.
 * @param context - Custom attributes attached to the action.
 */
export const trackAction = (name: string, context?: object) => {
  datadogRum.addAction(name, context);
};

/**
 * Sends a custom RUM error.
 *
 * @param error - The error, or a message describing it.
 * @param context - Custom attributes attached to the error.
 */
export const trackError = (error: unknown, context?: object) => {
  datadogRum.addError(error, context);
};

/**
 * Returns the RUM client itself, for third-party SDKs that integrate with it
 * (Flagsmith's `datadogRum` option). Application code should use
 * {@link trackAction}, {@link trackError} and the operation helpers instead.
 */
export const getRumClientForIntegrations = () => datadogRum;
